import React, { useState, useEffect } from 'react';
import Game from './Game';
import GameWrapper from './GameWrapper';
import EzoicIdentity from './EzoicIdentity';
import Leaderboard from './Leaderboard';

function App() {
  const [showLeaderboard, setShowLeaderboard] = useState(false);

  useEffect(() => {
    // Add event listener to the leaderboard button in the HTML
    const leaderboardBtn = document.getElementById('leaderboard-button');
    if (leaderboardBtn) {
      leaderboardBtn.addEventListener('click', (e) => {
        e.preventDefault();
        setShowLeaderboard(true);
      });
    }

    // Clean up on unmount
    return () => {
      if (leaderboardBtn) {
        leaderboardBtn.removeEventListener('click', () => {});
      }
    };
  }, []);

  return (
    <GameWrapper>
      <div className="App">
        <Game />
        {showLeaderboard && (
          <Leaderboard 
            show={showLeaderboard} 
            onClose={() => setShowLeaderboard(false)} 
          />
        )}
      </div>
    </GameWrapper>
  );
}

export default App;